app.controller('preloaderController', function (
    $scope,
    $stateParams,
    objectService,
    designLineService,
    imageService
) {
    $scope.isLoading = true
    $scope.isSuccessful = false
    $scope.percentLoaded = 0
    $scope.buyers = objectService.buyers
    $scope.status = objectService.getObject().status

    $scope.preview = objectService.getReviewMode()

    if(!objectService.getReviewMode() && objectService.hasPendingStatus()) {
        objectService.updateStatus()
    }

    function preLoadImages() {
        imageService.run().then(
            function handleResolve() { // Loading was successful.
                $scope.isLoading = false
                $scope.isSuccessful = true
                imageService.preloadDone(true)
            },
            function handleReject() { // Loading failed on at least one image.
                $scope.isLoading = false
                $scope.isSuccessful = false
            },
            function handleNotify(event) {
                $scope.percentLoaded = Math.round(30 + (event.percent*0.7))
            }
        )
    }

    function prepareImagePreloding(){
        var designLines = designLineService.designLines,
            groups = objectService.getQuestionGroups()

        angular.forEach(designLines, function(designline){
            imageService.preload(designline)
        })

        angular.forEach(groups, function(group){
            group.__img_group   = imageService.preload(group)
            group.__img_overlay = imageService.preload(group,true)

            angular.forEach(group.questions, function(question){
                if(question.type == QUESTION_TYPE.BOOLEAN){
                    question.__img_banner      = imageService.preload(question)
                    question.__img_alternative = imageService.preload(question,true)
                }
                angular.forEach(question.alternatives, function(alternative){
                    alternative.__img_banner      = imageService.preload(alternative)
                    alternative.__img_alternative = imageService.preload(alternative,true)

                    angular.forEach(alternative.media.dependencies, function(dependency){
                        imageService.preloadFromUrl(dependency.url)
                    })
                })
            })
        })
    }

    var fetchLoader = setInterval(function(){
        if($scope.percentLoaded < 20){
            $scope.$apply(function(){
                $scope.percentLoaded += 2
            })
        }
    }, 500);

    objectService.fetchObjectQuestions()
        .then(function(res){
            clearInterval(fetchLoader)
            $scope.percentLoaded = 20
            if(objectService.isInEarlyChoices()) {
                prepareImagePreloding()
                $scope.percentLoaded = 30
                preLoadImages()
            } else {
                var configuration = objectService.getCurrentConfiguration()

                designLineService.fetchDesignLines(configuration.id)
                    .then(function(a) {
                        prepareImagePreloding()
                        $scope.percentLoaded = 30
                        preLoadImages()
                    })
            }
    })


})
